// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Jzon from "rescript-jzon/lib/es6/src/Jzon.res.js";
import * as LumiDate from "lumi-rescript/lib/es6/src/LumiDate.res.js";
import * as LumiJzon from "lumi-rescript/lib/es6/src/LumiJzon.res.js";
import * as LumiResult from "lumi-rescript/lib/es6/src/LumiResult.res.js";
import * as Stdlib_Result from "@rescript/runtime/lib/es6/Stdlib_Result.js";
import * as Primitive_string from "@rescript/runtime/lib/es6/Primitive_string.js";

function fromString(s) {
  if (s === "") {
    return;
  } else {
    return s;
  }
}

function toString(s) {
  return s;
}

function coerce(k) {
  return k;
}

let compare = Primitive_string.compare;

function unsafeFromString(s) {
  if (s !== "") {
    return s;
  }
  throw {
    RE_EXN_ID: "Invalid_argument",
    _1: "key string is empty",
    Error: new Error()
  };
}

function jsonCodec() {
  let encode = s => Jzon.encodeWith(s, Jzon.string);
  let decode = json => Stdlib_Result.flatMap(Jzon.decodeWith(json, Jzon.string), str => {
    let s = fromString(str);
    if (s !== undefined) {
      return {
        TAG: "Ok",
        _0: s
      };
    } else {
      return {
        TAG: "Error",
        _0: {
          NAME: "UnexpectedJsonValue",
          VAL: [
            [],
            str
          ]
        }
      };
    }
  });
  return Jzon.custom(encode, decode);
}

let keyCodec_encode = {
  TAG: "ToJsonKeyString",
  _0: toString
};

let keyCodec_decode = {
  TAG: "FromJsonKeyString",
  _0: str => {
    let s = fromString(str);
    if (s !== undefined) {
      return {
        TAG: "Ok",
        _0: s
      };
    } else {
      return {
        TAG: "Error",
        _0: {
          NAME: "UnexpectedJsonValue",
          VAL: [
            [],
            str
          ]
        }
      };
    }
  }
};

let keyCodec = {
  encode: keyCodec_encode,
  decode: keyCodec_decode
};

let Key = {
  fromString: fromString,
  toString: toString,
  coerce: coerce,
  compare: compare,
  unsafeFromString: unsafeFromString,
  jsonCodec: jsonCodec,
  keyCodec: keyCodec
};

function jsonCodec$1(extCodec, contentCodec) {
  return Jzon.object5(param => [
    param.deleted,
    param.labelsHash,
    param.labels,
    param.ext,
    param.contents
  ], param => ({
    TAG: "Ok",
    _0: {
      deleted: param[0],
      labelsHash: param[1],
      labels: param[2],
      ext: param[3],
      contents: param[4]
    }
  }), Jzon.field("deleted", Jzon.bool), Jzon.field("labelsHash", Jzon.nullable(Jzon.string)), Jzon.field("labels", LumiJzon.setString), Jzon.field("ext", extCodec), Jzon.field("contents", contentCodec));
}

function flatMapContents(body, f) {
  return Stdlib_Result.map(f(body.contents), x => ({
    deleted: body.deleted,
    labelsHash: body.labelsHash,
    labels: body.labels,
    ext: body.ext,
    contents: x
  }));
}

function mapContents(body, f) {
  return {
    deleted: body.deleted,
    labelsHash: body.labelsHash,
    labels: body.labels,
    ext: body.ext,
    contents: f(body.contents)
  };
}

let Body = {
  jsonCodec: jsonCodec$1,
  flatMapContents: flatMapContents,
  mapContents: mapContents
};

function jsonCodec$2(extCodec, contentCodec) {
  return Jzon.object3(param => [
    param.labels,
    param.ext,
    param.contents
  ], param => ({
    TAG: "Ok",
    _0: {
      labels: param[0],
      ext: param[1],
      contents: param[2]
    }
  }), Jzon.field("labels", LumiJzon.setString), Jzon.field("ext", extCodec), Jzon.field("contents", contentCodec));
}

function flatMapContents$1(newBody, f) {
  return Stdlib_Result.map(f(newBody.contents), x => ({
    labels: newBody.labels,
    ext: newBody.ext,
    contents: x
  }));
}

function mapContents$1(newBody, f) {
  return {
    labels: newBody.labels,
    ext: newBody.ext,
    contents: f(newBody.contents)
  };
}

let NewBody = {
  jsonCodec: jsonCodec$2,
  flatMapContents: flatMapContents$1,
  mapContents: mapContents$1
};

let jsonCodec$3 = Jzon.custom(v => parseFloat(v), json => {
  if (typeof json === "number") {
    return {
      TAG: "Ok",
      _0: json.toString()
    };
  }
  return {
    TAG: "Error",
    _0: {
      NAME: "UnexpectedJsonType",
      VAL: [
        [],
        "number",
        json
      ]
    }
  };
});

function toString$1(revNum) {
  return revNum;
}

let RevNum = {
  jsonCodec: jsonCodec$3,
  toString: toString$1,
  beforeFirst: "0"
};

function jsonCodec$4(extCodec, contentCodec) {
  return Jzon.object3(param => [
    param.revNum,
    param.createTime,
    param.body
  ], param => ({
    TAG: "Ok",
    _0: {
      revNum: param[0],
      createTime: param[1],
      body: param[2]
    }
  }), Jzon.field("revNum", jsonCodec$3), Jzon.field("createTime", LumiDate.DateTime.jsonCodec), Jzon.field("body", jsonCodec$1(extCodec, contentCodec)));
}

function flatMapContents$2(rev, f) {
  return Stdlib_Result.map(flatMapContents(rev.body, f), x => ({
    revNum: rev.revNum,
    createTime: rev.createTime,
    body: x
  }));
}

let Revision = {
  jsonCodec: jsonCodec$4,
  flatMapContents: flatMapContents$2
};

function jsonCodec$5(extCodec, contentCodec) {
  return Jzon.object2(param => [
    param.key,
    param.rev
  ], param => ({
    TAG: "Ok",
    _0: {
      key: param[0],
      rev: param[1]
    }
  }), Jzon.field("key", jsonCodec()), Jzon.field("rev", jsonCodec$4(extCodec, contentCodec)));
}

function flatMapContents$3(doc, f) {
  return Stdlib_Result.map(flatMapContents$2(doc.rev, f), x => ({
    key: doc.key,
    rev: x
  }));
}

let Document = {
  jsonCodec: jsonCodec$5,
  flatMapContents: flatMapContents$3
};

function jsonCodec$6(tagCodec, valueCodec) {
  return Jzon.object2(param => [
    param.tag,
    param.value
  ], param => ({
    TAG: "Ok",
    _0: {
      tag: param[0],
      value: param[1]
    }
  }), Jzon.field("tag", tagCodec), Jzon.field("value", valueCodec));
}

function flatMap(st, f) {
  return Stdlib_Result.map(f(st.value), x => ({
    tag: st.tag,
    value: x
  }));
}

function withTag(value, tag) {
  return {
    tag: tag,
    value: value
  };
}

let SchemaTagged = {
  jsonCodec: jsonCodec$6,
  flatMap: flatMap,
  withTag: withTag
};

function jsonCodec$7(extCodec) {
  return jsonCodec$6(Jzon.string, jsonCodec$5(extCodec, Jzon.json));
}

function flatMap$1(someDoc, f) {
  return flatMap(someDoc, jsonDoc => flatMapContents$3(jsonDoc, f));
}

let SomeDocument = {
  jsonCodec: jsonCodec$7,
  flatMap: flatMap$1
};

function jsonCodec$8(extCodec) {
  return jsonCodec$6(Jzon.string, Jzon.array(jsonCodec$5(extCodec, Jzon.json)));
}

function asDocuments(x, codec) {
  return LumiResult.sequence(x.value.map(jsonDoc => flatMapContents$3(jsonDoc, json => Jzon.decodeWith(json, codec))));
}

let SomeDocuments = {
  jsonCodec: jsonCodec$8,
  asDocuments: asDocuments
};

function jsonCodec$9(extCodec) {
  return jsonCodec$6(LumiJzon.tuple2(Jzon.string, Jzon.string), Jzon.array(LumiJzon.tuple2(jsonCodec$5(extCodec, Jzon.json), jsonCodec$5(extCodec, Jzon.json))));
}

function asDocTup2s(x, jsonCodecA, jsonCodecB) {
  return LumiResult.sequence(x.value.map(param => LumiResult.sequence2([
    flatMapContents$3(param[0], json => Jzon.decodeWith(json, jsonCodecA)),
    flatMapContents$3(param[1], json => Jzon.decodeWith(json, jsonCodecB))
  ])));
}

let SomeDocTup2s = {
  jsonCodec: jsonCodec$9,
  asDocTup2s: asDocTup2s
};

function jsonCodec$10(extCodec) {
  return jsonCodec$6(LumiJzon.tuple2(Jzon.string, Jzon.string), Jzon.array(LumiJzon.tuple2(jsonCodec$5(extCodec, Jzon.json), Jzon.nullable(jsonCodec$5(extCodec, Jzon.json)))));
}

function asDocTup2Maybes(x, jsonCodecA, jsonCodecB) {
  return LumiResult.sequence(x.value.map(param => LumiResult.sequence2([
    flatMapContents$3(param[0], json => Jzon.decodeWith(json, jsonCodecA)),
    LumiResult.traverseOption(param[1], jsonDocB => flatMapContents$3(jsonDocB, json => Jzon.decodeWith(json, jsonCodecB)))
  ])));
}

let SomeDocTup2Maybes = {
  jsonCodec: jsonCodec$10,
  asDocTup2Maybes: asDocTup2Maybes
};

function jsonCodec$11(extCodec) {
  return jsonCodec$6(Jzon.string, jsonCodec$1(extCodec, Jzon.json));
}

let SomeBody = {
  jsonCodec: jsonCodec$11
};

function jsonCodec$12(extCodec) {
  return jsonCodec$6(Jzon.string, jsonCodec$2(extCodec, Jzon.json));
}

let SomeNewBody = {
  jsonCodec: jsonCodec$12
};

function asContents(x, codec) {
  return LumiResult.sequence(x.value.map(json => Jzon.decodeWith(json, codec)));
}

let SomeContents = {
  asContents: asContents
};

function toDoc(document) {
  return {
    key: document.key,
    contents: document.rev.body.contents
  };
}

function contents(document) {
  return document.rev.body.contents;
}

export {
  Key,
  Body,
  NewBody,
  RevNum,
  Revision,
  Document,
  SchemaTagged,
  SomeDocument,
  SomeDocuments,
  SomeDocTup2s,
  SomeDocTup2Maybes,
  SomeBody,
  SomeNewBody,
  SomeContents,
  toDoc,
  contents,
}
/* jsonCodec Not a pure module */
